import { Status, useFetchFeatureToursQuery } from 'domains/pickup-settings/api'

type PickupTour = 'pickup_analytics' | 'pickup_orders' | 'pickup_overview'

export function usePickupTourStatus(tourName: PickupTour) {
  const { data, loading, error, refetch } = useFetchFeatureToursQuery({
    fetchPolicy: 'no-cache',
  })
  const featureTours = data?.featureTours || []
  const pickupTour = featureTours.find(tour => tour?.name === tourName)

  const isTourPending = pickupTour?.status === Status.Pending.toLocaleLowerCase()
  const isTourCompleted = pickupTour?.status === Status.Completed.toLocaleLowerCase()
  const hoursPast = getHoursBetweenDates(new Date(pickupTour?.lastShownAt), new Date())

  const isTourShown = hoursPast < 24

  return { isTourPending, isTourCompleted, isTourShown, loading, error, refetch }
}

function getHoursBetweenDates(then: Date, now: Date) {
  // https://stackoverflow.com/questions/19225414/how-to-get-the-hours-difference-between-two-date-objects
  const msBetweenDates = Math.abs(then.getTime() - now.getTime())
  const hoursBetweenDates = msBetweenDates / 36e5

  return hoursBetweenDates
}
